import Unauthorized from './Unauthorized'

const user = { Unauthorized }

export default user
